import axios from '@/plugins/axios/https';

export function ApiCampaignsList({ mediaType, status, search, limit, offset, ordering }) {
  const form = {
    mediaType,
    limit,
    offset,
    ordering
  };

  if (status > -2) {
    form.status = status;
  }

  if (search) {
    form.search = search;
  }

  return axios.get('/campaign/campaigns/', form);
}

export function ApiCampaignCreate({ name, mediaType }) {
  const form = {
    name,
    mediaType
  };
  return axios.post('/campaign/campaigns/create/', form);
}

export function ApiCampaignProfile({ uuid }) {
  return axios.get(`/campaign/campaigns/${uuid}/profile/`);
}

export function ApiCampaignDelete({ uuid }) {
  return axios.post(`/campaign/campaigns/${uuid}/remove/`);
}

export function ApiCampaignCopy({ uuid, name }) {
  const form = {
    name
  };
  return axios.post(`/campaign/campaigns/${uuid}/copy/`, form);
}

export function ApiCampaignSave({ uuid, name, instant, startAt, retryAt }) {
  const form = {
    name,
    instant,
    startAt,
    retryAt
  };

  return axios.post(`/campaign/campaigns/${uuid}/save/`, form);
}

export function ApiCampaignSend({ uuid }) {
  return axios.post(`/campaign/campaigns/${uuid}/send/`);
}

export function ApiCampaignCancel({ uuid }) {
  return axios.post(`/campaign/campaigns/${uuid}/cancel/`);
}

export function ApiReferrerInfo() {
  return axios.get(
    '/campaign/campaigns/get-recommender-info/',
    {},
    {
      loading: false
    }
  );
}

export function ApiGetCampaignSet() {
  return axios.get('/campaign/settings/');
}

export function ApiSetCampaignSet({
  abTestInterval,
  abTestThreshold,
  emailSubjectPrefix,
  emailSubjectSuffix,
  edmHeader,
  edmFooter,
  unsubscribeLink
}) {
  const form = {
    abTestInterval,
    abTestThreshold,
    emailSubjectPrefix,
    emailSubjectSuffix,
    edmHeader,
    edmFooter,
    unsubscribeLink
  };

  return axios.post('/campaign/settings/', form);
}

export function ApiGetCampaignPreviewerSet() {
  return axios.get('/campaign/previewer-settings/');
}

export function ApiSetCampaignPreviewerSet({
  previewSmss,
  previewMails,
  fromName,
  fromMail,
  replyToMai
}) {
  const form = {
    previewSmss,
    previewMails,
    fromName,
    fromMail,
    replyToMai
  };

  return axios.post('/campaign/previewer-settings/', form);
}

